module.exports = __webpack_public_path__ + "static/media/28DGC1.ed9fdf25.jpg";